import { Controller } from "@hotwired/stimulus";

// Toggle the blur on sensitive fields (BA, sécu, IBAN) and provide a copy
// button that writes the targeted value to the clipboard. The blur effect
// itself is driven by the `data-reveal-revealed` attribute (CSS hooks on
// `[data-controller="reveal"][data-reveal-revealed="false"]`).
export default class extends Controller {
  static targets = ["iconShow", "iconHide", "label"];

  connect() {
    this._setRevealed(false);
  }

  toggle(event) {
    event?.preventDefault();
    const next = this.element.dataset.revealRevealed !== "true";
    this._setRevealed(next);
  }

  copy(event) {
    event?.preventDefault();
    const value = event.currentTarget.dataset.clipboard;
    if (!value) return;
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(value).then(() => this._flash(event.currentTarget));
    } else {
      // Legacy fallback.
      const ta = document.createElement("textarea");
      ta.value = value;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); } catch (_e) { /* noop */ }
      document.body.removeChild(ta);
      this._flash(event.currentTarget);
    }
  }

  _setRevealed(state) {
    this.element.dataset.revealRevealed = String(state);
    if (this.hasIconShowTarget) this.iconShowTarget.hidden = state;
    if (this.hasIconHideTarget) this.iconHideTarget.hidden = !state;
    if (this.hasLabelTarget) this.labelTarget.textContent = state ? "Masquer" : "Révéler";
  }

  _flash(btn) {
    const original = btn.innerHTML;
    btn.innerHTML = '<i class="fa-solid fa-check"></i>';
    btn.style.color = "var(--ds-color-success-600)";
    setTimeout(() => { btn.innerHTML = original; btn.style.color = ""; }, 1100);
  }
}
